export const n8nWebhookUrls = {
  production: 'https://dev.n8n.ablefy.ai/webhook',
  staging: 'https://dev.n8n.ablefy.ai/webhook',
  development: 'https://dev.n8n.ablefy.ai/webhook-test',
  test: 'https://dev.n8n.ablefy.ai/webhook',
  uat: 'https://dev.n8n.ablefy.ai/webhook',
} as const

export const getN8nWebhookUrl = () => {
  const env = process.env.ENV || 'development'
  return n8nWebhookUrls[env] || n8nWebhookUrls.development
}
